import React from "react";
import * as styles from "./Button.module.scss";
import iconWhite from "../../../icons/arrows/white-right-arrow.svg";

const colorStyles = {
  lightblue: styles.color_lightblue,
  red: styles.color_red,
  orange: styles.color_orange,
  yellow: styles.color_yellow,
  green: styles.color_green,
  blue: styles.color_blue,
  white: styles.color_white,
  black: styles.color_black,
  violet: styles.color_violet
};

const colorStylesBorder = {
  lightblue: styles.color_lightblue_border,
  red: styles.color_red_border,
  orange: styles.color_orange_border,
  yellow: styles.color_yellow_border,
  green: styles.color_green_border,
  blue: styles.color_blue_border,
  white: styles.color_white_border,
  black: styles.color_black_border,
  
};

const sizeStyles = {
  standard: styles.button_standard,
  large: styles.button_large,
};

const Button = ({
  text,
  icon,
  color = "black",
  size = "standard",
  onClick,
  colorCategory,
  border = false,
}) => {
  const sizeClass = sizeStyles[size] || styles.button_standard;

  const colorClass = border
    ? colorCategory
      ? colorStylesBorder[colorCategory]
      : colorStylesBorder[color]
    : colorCategory
    ? colorStyles[colorCategory]
    : colorStyles[color];

  return (
    <button
      className={`${styles.button__container} ${colorClass} ${sizeClass}`}
      onClick={onClick}
    >
      {text}
      {colorCategory
        ? icon && <img src={iconWhite} alt={text} />
        : icon && <img src={icon} alt={text} />}
    </button>
  );
};

export default Button;